// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"93":"list","180":"story"}[chunkId] + "-" + {"93":"d088479251d7c3625c51","180":"52670d70662b10d05c62"}[chunkId] + ".css";
};